import { FC } from 'react';
import { Button, Box } from 'src/components/ui';
import { VscRunAll } from 'react-icons/vsc';

interface AppExecuteProps {
	onExecute: () => void;
	isLoading?: boolean;
	isDisabled?: boolean;
}

const AppExecute: FC<AppExecuteProps> = ({ onExecute, ...props }) => {
	return (
		<Box
			position={{ base: 'fixed', md: 'relative' }}
			bottom={{ base: 0, md: 'auto' }}
			left={{ base: 0, md: 'auto' }}
			right={{ base: 0, md: 'auto' }}
			bg={{ base: 'white', md: 'transparent' }}
			p={{ base: 4, md: 0 }}
			boxShadow={{ base: '0 -2px 10px rgba(0, 0, 0, 0.1)', md: 'none' }}
			zIndex={{ base: 1000, md: 'auto' }}
			display="flex"
			justifyContent={{ base: 'center', md: 'flex-end' }}
		>
			<Button
				borderRadius="38px"
				bgColor="orange.base"
				color="white"
				fontSize="14px"
				_hover={{ bg: 'orange.base' }}
				onClick={onExecute}
				maxW={{ base: '100%', md: 100 }}
				w={{ base: '100%', md: 'auto' }}
				p={5}
				leftIcon={<VscRunAll size={20} />}
				boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
				{...props}
			>
				Run
			</Button>
		</Box>
	);
};

export default AppExecute;
